import { useQuery } from '@tanstack/react-query';
import { OTPApi } from '../../../apis/OTPApi/OTPApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IOTPTimelineEvent } from '../OTP';

export function useOTPTimeline(otpId: number | undefined) {
    return useQuery<IOTPTimelineEvent[]>({
        queryKey: [QueryKeys.otp, 'timeline', otpId],
        queryFn: () => OTPApi.getOTPTimeline(otpId!),
        enabled: !!otpId,
    });
}
